export default {
  primary: '#5E689B',
  primaryLight: '#757EAB',
  primaryDark: '#505989',
  grey: '#BBB9CA',
  lightGrey: '#F3F4F5',
  white: '#FFFFFF',
  secondaryBorder: '#CCCCCC',
  secondaryHover: '#F7F7F7',
  inputGrey: '#F3F4F5',
  inputLabelGrey: '#7C7C7F',
  inputTextGrey: '#B8BEC4',
  inputFocusedPlaceholder: '#D4D5D6',
  black: '#242735',
  green: '#19B686',
  secondaryGreen: '#53C8A4',
  lightGreen: '#C5EDE1',
  error: '#c85353',
}
